import React, { Fragment, useEffect } from 'react';
// import logo from './logo.svg';
import './App.css';
// import MainBody from './components/MainBody';
// import BlogMarkdown from './components/BlogMarkdown';
// import BlogsMenu from './components/BlogsMenu'
import  { paths } from './components/MyRoutes' ;
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import MyNavBar from './components/NavBar';
import { createBrowserHistory } from 'history';
import BlogMarkdown from './components/BlogMarkdown';
import BlogsMenu from './components/BlogsMenu';
import MainBody from './components/MainBody';


const history = createBrowserHistory();

function App() {

  useEffect(()=>{
    // this is for the goatcounter analytics
    const script = document.createElement("script")
    script.src="/scripts/count.js"
    script.setAttribute("data-goatcounter", "https://brilliant.goatcounter.com/count")
    document.body.appendChild(script);
  })


  let returnComp =  (
    <Router
    //@ts-ignore
     history={history}>
      <MyNavBar />
      <Routes>
            <Route path={paths.home} element={<MainBody/>}/>
            <Route path={paths.home2} element={<MainBody/>}/>
            <Route path={paths.blogsMenu} element={<BlogsMenu/>}/>
            <Route path={paths.blog} element={<BlogMarkdown/>}/>
      </Routes>
    </Router>
  );
  return returnComp;
}

export default App;
